import { EStatisticsTab, EStatisticsTimespan } from "./domain/enums";
import { SelectComponent } from "@karma-games/angular-devkit/modules/controls-components";
import IOption = SelectComponent.IOption;

export const statisticsWidthMap = {
    user: "31%",
    date: "31%",
    bet: "20.3%",
    multiplier: "25.3%",
    cashout: "23.3%",
    totalAmount: "23.3%"
};

export const labelCategoryMap = {
    [EStatisticsTab.AllBets]: [
        { text: { key: "USER" }, width: statisticsWidthMap.user },
        { text: { key: "BET" }, width: statisticsWidthMap.bet },
        { text: { key: "MULTIPLIER" }, width: statisticsWidthMap.multiplier },
        { text: { key: "CASHOUT" }, width: statisticsWidthMap.totalAmount },
    ],
    [EStatisticsTab.MyBets]: [
        { text: { key: "DATE" }, width: statisticsWidthMap.date },
        { text: { key: "BET" }, width: statisticsWidthMap.bet },
        { text: { key: "MULTIPLIER" }, width: statisticsWidthMap.multiplier },
        { text: { key: "CASHOUT" }, width: statisticsWidthMap.totalAmount },
    ],
    [EStatisticsTab.TopBets]: [
        { text: { key: "USER" }, width: statisticsWidthMap.user },
        { text: { key: "BET" }, width: statisticsWidthMap.bet },
        { text: { key: "MULTIPLIER" }, width: statisticsWidthMap.multiplier },
        { text: { key: "CASHOUT" }, width: statisticsWidthMap.totalAmount },
    ]
};

export const statisticsPanelTabs: IOption[] = [
    { text: { key: "ALL_BETS" }, value: EStatisticsTab.AllBets },
    { text: { key: "MY_BETS" }, value: EStatisticsTab.MyBets },
    { text: { key: "TOP_BETS" }, value: EStatisticsTab.TopBets }
];

export const topBetsTimespanOptions: IOption<EStatisticsTimespan>[] = [
    { text: { key: "TIMESPAN.TODAY" }, value: EStatisticsTimespan.Today },
    { text: { key: "TIMESPAN.WEEK" }, value: EStatisticsTimespan.Week },
    { text: { key: "TIMESPAN.MONTH" }, value: EStatisticsTimespan.Month },
    { text: { key: "TIMESPAN.YEAR" }, value: EStatisticsTimespan.Year }
];

export const statisticsRecordsPageLength: number = 30;
